import { getPayments } from 'controllers/OwnerController'
import { getETHRate } from 'eth/ethUtils'
import { displayLocalPrice } from 'eth/ethUtils'
import { useEffect } from 'react'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import moment from 'moment'
import { getActiveChainName } from 'eth/ethUtils'

export const PAYMENT_TYPES = [
    { code: '[p1]', message: 'Mint Fee' },
    { code: '[p2]', message: 'Royalty' },
    { code: '[p5]', message: 'Tx fee' },
    { code: '[p10]', message: 'Purchase' },
    { code: '[p11]', message: 'Purchase fee' },
    { code: '[p20]', message: 'Share purchase' },
    { code: '[p21]', message: 'Share purchase fee' },
    { code: '[p50]', message: 'Partner distribution' },
    { code: '[p60]', message: 'Partner share purchase' },
    { code: '[p61]', message: 'Partner share purchase fee' },
]
export default function Payments({ address }) {
    const [payments, setPayments] = useState([])
    const [ethInCurrency, setEthInCurrency] = useState(0)
    const { currency, showEthInCurrency } = useSelector((state) => state.settings)
    const displayType = (paymentType) => {
        const type = PAYMENT_TYPES.find((p) => p.code === paymentType)
        return type ? type.message : null
    }
    const displayHeader = () => {
        return (
            <div style={{ display: 'flex', textAlign: 'left' }}>
                <span style={{ flex: '25%' }}>Amount</span>
                <span style={{ flex: '25%', textAlign: 'left' }}>For</span>
                <span style={{ flex: '50%', textAlign: 'left' }}>Received</span>
            </div>
        )
    }
    const displayPayment = (payment, index) => {
        const { amount, received, paymentType, txHash } = payment
        let chainHost = ''
        const chainName = getActiveChainName()
        if (chainName && chainName !== 'mainnet') {
            chainHost = `${chainName}.`
        }
        const url = `https://${chainHost}etherscan.io/tx/${txHash}`
        return (
            <div
                key={index}
                style={{
                    display: 'flex',
                    cursor: 'pointer',
                }}
                title='Click to view transaction'
                onClick={() => window.open(url, '_blank')}
            >
                <span style={{ flex: '25%' }}>
                    {displayLocalPrice(
                        amount / 10 ** 18,
                        ethInCurrency,
                        currency,
                        showEthInCurrency,
                        8
                    )}
                </span>
                <span style={{ flex: '25%', textAlign: 'left' }}>
                    {displayType(paymentType)}
                </span>
                <span style={{ flex: '50%', textAlign: 'left' }}>
                    {moment(received).format('MMMM Do YYYY, h:mm:ss a')}
                </span>
            </div>
        )
    }
    const fetchPayments = async () => {
        try {
            const results = await getPayments(address)
            if (results) {
                const { payments } = results
                console.log('got payments', payments)
                payments.sort((a, b) => {
                    return a.received < b.received ? 1 : a.received > b.received ? -1 : 0
                })
                setPayments(payments)
                getRate()
            }
        } catch (error) {
            console.error('Unable to fetchPayments', error)
        }
    }
    const getRate = () => {
        getETHRate(currency).then((rate) => setEthInCurrency(rate))
    }
    useEffect(() => {
        fetchPayments()
    }, [])
    if (payments.length) {
        return (
            <div>
                <h4>Payments Received</h4>
                {displayHeader()}
                {payments.map((p, index) => displayPayment(p, index))}
            </div>
        )
    } else {
        return null
    }
}